import { MetricsForJumboEvent } from '../../../../../../analytics/constants';
import { RaiseAnIssueNextBtnClickEvent } from '../../../../../../analytics/raise-an-issue/events';
import { RAProceedBtnClickEvent } from '../../../../../../analytics/reso-assist/events';
import { reasonModel } from '../../../../../../api';
import { DSR_COMMENT } from '../constants';

export const coreEvaluate = ({
  orderId,
  cartId,
  userId,
  complaintType,
  issueInfo,
  selectedMultiRangeOptions,
  orderLevelCharges,
  selectedSubItemList,
  handleComplaintImgvisibilty,
  UpdateNextScreen = () => {},
  isDsrResolveFlowActivatedProp,
  isViaResoAssistFlow = false,
}) => {
  const rawSelectedItems = [
    ...Object.values(selectedMultiRangeOptions || {}),
    ...(Array.isArray(selectedSubItemList) ? selectedSubItemList : []),
  ];
  const selectedItems = Array.from(
    rawSelectedItems.reduce(
      (map, item) => map.set(item?.item_id, item),
      new Map(),
    ),
    ([, item]) => item,
  );

  UpdateNextScreen({
    isLoading: true,
  });

  const orderLevelChargesInputKey = issueInfo?.order_level_select?.input?.key;

  let dataForEvaluate = {
    order_id: orderId,
    cart_id: cartId,
    complaint_type: complaintType,
    selected_items: selectedItems,

    // DSR keys
    ...(issueInfo?.is_dsr_flow
      ? {
          is_pre_del_complaint: true,
          ...(typeof window !== 'undefined' &&
          localStorage.getItem(DSR_COMMENT) &&
          localStorage.getItem(DSR_COMMENT) !== ''
            ? { comment: localStorage.getItem(DSR_COMMENT) }
            : {}),
        }
      : {}),
  };

  if (orderLevelChargesInputKey) {
    dataForEvaluate = {
      ...dataForEvaluate,
      [`${orderLevelChargesInputKey}`]: orderLevelCharges,
    };
  }

  handleComplaintImgvisibilty();

  // response meta for event tracking
  const response_meta = {};

  if (!isDsrResolveFlowActivatedProp && issueInfo?.is_dsr_flow) {
    UpdateNextScreen({
      isLoading: false,
      showResolutionOptions: true,
      resolutionOptionDetails: dataForEvaluate,
    });
    RaiseAnIssueNextBtnClickEvent({
      [MetricsForJumboEvent.order_id]: orderId,
      [MetricsForJumboEvent.cart_id]: cartId,
      [MetricsForJumboEvent.customer_id]: userId,
      [MetricsForJumboEvent.feature_meta]: {
        is_dsr_flow: issueInfo?.is_dsr_flow,
        dsr_item_to_be_resolved: dataForEvaluate,
      },
    });
    return;
  }

  reasonModel
    .evaluateResolution(dataForEvaluate)
    .then((response) => {
      if (!response) return null;
      if (response && response.isError === true) {
        response_meta.is_success = false;
        UpdateNextScreen({
          isLoading: false,
          isError: true,
          errorMessage: response?.message || 'Something went wrong',
        });
      } else {
        response_meta.is_success = true;
        response_meta.complaint_id = response?.complaint_id;
        response_meta.values = JSON.stringify(
          response?.support_options?.options?.map((option) => {
            if (!option) return null;
            return {
              title: option?.title || '',
              values:
                option?.children
                  ?.map((child) =>
                    child?.children
                      ?.map((subChild) =>
                        subChild?.options
                          ?.map((subChildOption) =>
                            subChildOption?.children
                              ?.map(
                                (subChildChild) => subChildChild?.title || '',
                              )
                              .filter(Boolean),
                          )
                          .flat()
                          .filter(Boolean),
                      )
                      .flat()
                      .filter(Boolean),
                  )
                  .flat()
                  .filter(Boolean) || [],
            };
          }) || [],
        );

        UpdateNextScreen({
          isLoading: false,
          ...(issueInfo?.is_dsr_flow
            ? {
                showSuccessScreen: true,
                resolutionSuccessDetails: response,
              }
            : {
                showResolutionOptions: true,
                resolutionOptionDetails: response,
                showResoAssistScreen: false,
              }),
        });
      }

      return response;
    })
    .catch(() => {
      response_meta.is_success = false;
      UpdateNextScreen({
        isLoading: false,
        isError: true,
        errorMessage: 'Something went wrong',
      });
    })
    .then(() => {
      const payload = {
        [MetricsForJumboEvent.order_id]: orderId,
        [MetricsForJumboEvent.cart_id]: cartId,
        [MetricsForJumboEvent.customer_id]: userId,
        [MetricsForJumboEvent.feature_meta]: {
          'dataForEvaluate.complaint_type': complaintType,
          'dataForEvaluate.selected_items': JSON.stringify(selectedItems),
          'response_meta.complaint_id': response_meta.complaint_id,
          'response_meta.is_success': response_meta.is_success,
          'response_meta.values': response_meta.values,
        },
      };
      if (isViaResoAssistFlow) {
        RAProceedBtnClickEvent(payload);
      } else {
        RaiseAnIssueNextBtnClickEvent(payload);
      }
    });
};
